export default class ShopCart extends HTMLElement {
    open: boolean = false
    includeBackdrop: boolean = false

    cartEl: HTMLElement | null = null
    backdropEl: HTMLElement | null = null
    closeBtnEl: HTMLElement | null = null
    cartScrollEl: HTMLElement | null = null

    static get observedAttributes() {
        return ['open']
    }

    constructor() {
        super()

        this.includeBackdrop = this.getAttribute('include-backdrop') === 'true'

        this.cartEl = this.querySelector<HTMLElement>('aside[data-cart]') as HTMLElement
        this.backdropEl = this.querySelector<HTMLElement>('aside[data-cart-backdrop]') as HTMLElement
        this.closeBtnEl = this.querySelector<HTMLElement>('button[data-cart-close]') as HTMLElement
        this.cartScrollEl = this.querySelector<HTMLElement>('[data-ajax-cart-section-scroll]') as HTMLElement

        // Event listeners

        this.closeBtnEl?.addEventListener('click', this.handleClick.bind(this))
        ;(window as any).addEventListener('cart:toggle', this.handleCart.bind(this))
        document.addEventListener('click', this.handleClickOutside.bind(this))

        // Bind cart data
        // @ts-ignore
        document.addEventListener('liquid-ajax-cart:request-end', this.handleAjaxCart.bind(this))
        document.addEventListener('liquid-ajax-cart:init', this.handleAjaxCartInit.bind(this))
    }

    get isOpen() {
        return this.open
    }

    set isOpen(value: boolean) {
        this.open = value
        this.setAttribute('open', value.toString())
        this.toggle()
    }

    handleAjaxCart(evt: CustomEvent) {
        const { cart, requestState } = evt.detail
        const { requestType } = requestState

        if (requestType === 'add' && cart.item_count > 0) {
            this.isOpen = true
        }

        window.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { cart, requestType } }))
    }

    handleAjaxCartInit(evt: CustomEvent) {
        // Add formatter to liquidAjaxCart
        window.liquidAjaxCart.conf('binderFormatters', {
            my_formatter: (value) => {
                // Don't change anything if the value is not a number
                if (typeof value !== 'number' && !(value instanceof Number)) {
                    return value
                }

                // Apply formatMoney function if it exists
                if (window.Shopify?.formatMoney) {
                    return window.Shopify.formatMoney(value)
                }

                // Fallback to the "100 USD" format if there is no Shopify.formatMoney
                return `${value.toFixed(2)} ${window?.liquidAjaxCart?.cart?.currency}`
            },
        })
    }

    handleCart(evt: CustomEvent) {
        this.isOpen = evt.detail.open
    }

    handleClick(evt: Event) {
        evt.preventDefault()

        window.dispatchEvent(new CustomEvent('cart:toggle', { bubbles: true, detail: { open: false } }))
    }

    toggle() {
        if (this.isOpen) {
            // Cart
            this.cartEl?.classList.add('!right-0', '!opacity-100')

            // Backdrop
            if (this.includeBackdrop) {
                this.backdropEl?.classList.remove('!opacity-0', 'pointer-events-none')
            }

            // Body
            document.body.style.height = '100vh'
            document.body.style.overflow = 'hidden'
        } else {
            // Cart
            this.cartEl?.classList.remove('!right-0', '!opacity-100')

            // Backdrop
            if (this.includeBackdrop) {
                this.backdropEl?.classList.add('!opacity-0', 'pointer-events-none')
            }

            // Body
            document.body.style.height = ''
            document.body.style.overflow = ''

            // Scroll to the top of the cart
            setTimeout(() => {
                this.cartScrollEl?.scrollTo({ top: 0, behavior: 'auto' })
            }, 250)
        }
    }

    handleClickOutside(evt: MouseEvent) {
        if (!this.isOpen) return

        const target = evt.target as HTMLElement
        if (this.cartEl && !this.cartEl.contains(target) && !target.hasAttribute('data-cart-button')) {
            window.dispatchEvent(new CustomEvent('cart:toggle', { bubbles: true, detail: { open: false } }))
        }
    }
}

customElements.define('shop-cart', ShopCart)
